export const getInitialValues = (eventType) => ({
  guestsAllowed: eventType.guests_allowed
})
